module.exports = __webpack_public_path__ + "summernote.ce9ce49a0e1ca283fa24.ttf";


//////////////////
// WEBPACK FOOTER
// /rightcompound/angular/node_modules/summernote/dist/font/summernote.ttf?0d0d5fac99cc8774d89eb08b1a8323c4
// module id = ../../../../summernote/dist/font/summernote.ttf?0d0d5fac99cc8774d89eb08b1a8323c4
// module chunks = styles